module.exports = __webpack_public_path__ + "img/wap_phone1@2x.1aac7347.png";